import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_paper_novelty: FaireCategoryEntity = {
  token: "cat_paper-novelty",
  type: "category",
  name: "Paper & novelty",
  level: 1,
  href: "/category/paper-novelty",
  childCategoryTokens: [
    "cat_paper-all",
    "cat_paper-new-products",
    "cat_paper-new-brands",
    "cat_paper-bestsellers",
    "cat_paper-stationery",
    "cat_paper-party",
  ],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
